import React, { useEffect } from 'react';
import { Button, Typography } from '@mui/material';
import Screen from '../Screen';
import usePrequal from '../../resources/prequal/usePrequal';
import useMerchant from '../../resources/merchant/read';

const CheckoutSuccess = () => {
  const { data: prequal } = usePrequal();
  const { data: merchant } = useMerchant(prequal.merchantId, { suspense: true });

  useEffect(() => {
    setTimeout(() => {
      window.location.replace(prequal.redirectUri);
    }, 5_000);
  });

  return (
    <Screen
      header="You're all set!"
      subheader={(
        <>
          Your financing has been approved and your terms are confirmed.
          You’ll be redirected back to
          {' '}
          {merchant.name}
          {' '}
          to complete your checkout.
          <br />
          <br />
          If you’re not redirected automatically, click below to continue.
        </>
    )}
    >
      <Button href={prequal.redirectUri}>
        Return to Merchant
      </Button>
      <Typography align="center" variant="caption">
        Redirecting in 5 seconds...
      </Typography>
    </Screen>
  );
};

export default CheckoutSuccess;
